exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, ".ct-next-gen-widget{width:100%;overflow:hidden;border:none}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader?minimize!./client/helpers/css/next-gen-widget-iframe.css
 ** module id = 3
 ** module chunks = 0
 **/